import React, { useEffect, useState, memo } from 'react';
import { DriverTVCard } from './DriverTVCard';
import styles from '../styles.module.css';
import { format } from 'date-fns';

import nextCargoLogo from '../assets/next-cargo-logo.svg';
import { DriverCalled, DriverCalledQueue, TV } from '../DriversTV';
import { useWindowReload, useDriverCall } from '../../../hooks';
import { CompanyHostApi } from '../../../domain';
import { TVLogo, TVLogoType } from './TVLogo';
import { CountAttendance } from './CountAttendance';

interface Props {
  driverCalledQueue: DriverCalledQueue;
  setDriverCalledQueue: React.Dispatch<React.SetStateAction<DriverCalledQueue>>;
  attendeds: number;
  tvList: TV[];
  company: CompanyHostApi | null;
  refetchDriverList: () => Promise<void>;
}

export const DriverTVContent = memo(({ driverCalledQueue, setDriverCalledQueue, attendeds, tvList, company, refetchDriverList }: Props) => {
  useWindowReload();

  // Utilizando o novo hook useDriverCall
  const { isCallingDriver, callDriver } = useDriverCall();

  const [sortList, setSortList] = useState(false);
  const [currentDriverCalled, setCurrentDriverCalled] = useState<DriverCalled | null>(null);

  let panel = sortList
    ? tvList.filter((it) => Number(it.driverTv.id) !== currentDriverCalled?.id)
    : currentDriverCalled
    ? tvList.filter((it) => Number(it.driverTv.id) !== currentDriverCalled.id)
    : tvList;

  const list = panel.sort((a, b) => new Date(b.driverTv.called_at).getTime() - new Date(a.driverTv.called_at).getTime()).slice(0, 10);

  // Efeito para definir o motorista atual quando não está chamando
  useEffect(() => {
    if (!isCallingDriver && list.length > 0 && !currentDriverCalled) {
      const lastDriver = list[list.length - 1];
      setCurrentDriverCalled(lastDriver.driverTv);
    }
  }, [list, currentDriverCalled, isCallingDriver]);

  useEffect(() => {
    const handleDriverCall = async () => {
      if (!driverCalledQueue.driverCalled) {
        console.log('❌ DriverTVContent - Sem driverCalled, não executando');
        return;
      }

      // Usar o hook para chamar o motorista com callbacks
      await callDriver(driverCalledQueue.driverCalled, {
        onBeforeCall: () => {
          console.log('🔊 DriverTVContent - Preparando para chamar:', driverCalledQueue.driverCalled?.queue?.driver?.name);
          setSortList(true);
        },
        onCallStart: () => {
          console.log('🎤 DriverTVContent - Iniciando chamada para:', driverCalledQueue.driverCalled?.queue?.driver?.name);
          setCurrentDriverCalled(driverCalledQueue.driverCalled);
        },
        onCallEnd: () => {
          console.log('✅ DriverTVContent - Chamada finalizada para:', driverCalledQueue.driverCalled?.queue?.driver?.name);

          // Pega o próximo da fila e atualiza o estado
          setDriverCalledQueue(prev => {
            const nextDriver = prev.queue.shift(); // Remove e retorna o primeiro item da fila

            console.log('🔄 DriverTVContent - Próximo motorista da fila:', nextDriver?.queue?.driver?.name || 'Nenhum');

            return {
              driverCalled: nextDriver || null,
              queue: [...prev.queue] // Cria nova array com os itens restantes
            };
          });
        },
      });
    };

    handleDriverCall();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [driverCalledQueue.driverCalled]);

  return (
    <div className={styles.content}>
      <section className={styles.next}>
        <div className={styles.images}>
          <img src={nextCargoLogo} alt="" />

          {company && <TVLogo logo={company?.id.toString() as TVLogoType} alt={company?.name} />}
        </div>

        <div className={styles.driver}>
          <p>Próximo</p>

          {currentDriverCalled && (
            <div className={styles.details}>
              <time>{format(new Date(currentDriverCalled.called_at), "dd/MM '•' HH'h'mm")}</time>

              <div className={styles['truck-license-plate']}>{currentDriverCalled?.queue?.truck.licensePlate}</div>
              <span className={styles.name}>
                {currentDriverCalled?.queue?.driver.name}
                {/* {isCallingDriver && <span style={{ color: 'red' }}> (Chamando...)</span>} */}
              </span>
            </div>
          )}
        </div>
      </section>

      <section className={styles.summary}>
        <div className={styles.grid}>
          {list.map((item) => (
            <DriverTVCard driverTv={item.driverTv} inAttendance={item.inAttendance} key={item.driverTv.id} />
          ))}
        </div>

        <CountAttendance attendeds={attendeds} refetchDriverList={refetchDriverList} />
      </section>
    </div>
  );
});
DriverTVContent.displayName = 'DriverTVContent';
